import React from 'react'

const ReceiptContext = React.createContext()

export default ReceiptContext
